import positionToStringId from '../../utils/positionToStringId.js';
function getVacantNeighbours(agentUnit, rules, allUnits, rankedPositionsById) {
    const agentNeighbours = rules.getExistingNeighbours(agentUnit.position);
    const vacantNeighbours = agentNeighbours.filter((n) => rules.getUnitOnPosition(n, allUnits) ? false : true);
    vacantNeighbours.sort((a, b) => {
        const aRank = rankedPositionsById[positionToStringId(a)]?.rank ?? 0;
        const bRank = rankedPositionsById[positionToStringId(b)]?.rank ?? 0;
        return bRank - aRank;
    });
    return vacantNeighbours;
}
export default getVacantNeighbours;
